export default "__VITE_ASSET__BvQN2_0r__"